export default {
	subsription_pay: "subsription_pay",
	google_iap_transaction: "google_iap_transaction",
	subsription_get_sale: "subsription_get_sale",
};
